import { render, staticRenderFns } from "./blankSpace.vue?vue&type=template&id=109d4ff5&scoped=true"
import script from "./blankSpace.vue?vue&type=script&lang=js"
export * from "./blankSpace.vue?vue&type=script&lang=js"
import style0 from "./blankSpace.vue?vue&type=style&index=0&id=109d4ff5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109d4ff5",
  null
  
)

export default component.exports